import React from 'react';
import Loadable from '@loadable/component';

import './product-statement.styles.scss';

const Slide = Loadable(() => import('react-reveal/Slide'));

const ProductStatement: React.FC = () => {
  return (
    <>
      <div className="ptb-100">
        <div className="container">
          <div className="section-title">
            <span className="sub-title">Offerings</span>
            <h2>We Pickup Where Transit Drops Off</h2>
            <p>
              Hop In improves the daily commute by extending mass transit’s
              reach to hard-to-access areas
            </p>
          </div>

          <Slide left>
            <div className="product-statement">
              <div className="product-statement-content">
                <div className="content">
                  <span className="sub-title">The Problem</span>
                  <h2>Issues with hard to reach worksites/offices</h2>
                  <p>
                    Many people apply only for jobs only within arms reach of
                    their own neighbourhoods for fear of a long and dreadful
                    commute.
                  </p>

                  <div className="features-text">
                    <h5>
                      <i className="bx bxs-lock-alt"></i> Lack of Transportation
                      Options
                    </h5>
                    <p>
                      In areas with lacking transportation options,
                      <b>access is a major concern. </b>
                    </p>
                  </div>

                  <div className="features-text">
                    <h5>
                      <i className="bx bxs-lock-alt"></i> Need of a personal
                      vehicle
                    </h5>
                    <p>
                      <b>Commutes to work are nearly impossible</b> without a
                      personal vehicle.
                    </p>
                  </div>

                  <div className="features-text">
                    <h5>
                      <i className="bx bxs-lock-alt"></i> Problems with hiring
                      and retaining talent
                    </h5>
                    <p>
                      Companies have{' '}
                      <b>
                        difficulties with retaining talent and in expanding
                        hiring pools.
                      </b>
                    </p>
                  </div>
                </div>
              </div>

              <div className="product-statement-image">
                <div className="image">
                  <img
                    src={require('../../../assets/photos/product-statement/problem-statement.png')}
                    alt="problem statement"
                  />
                </div>
              </div>
            </div>
          </Slide>
        </div>
      </div>
      <div className="ptb-100 pt-0">
        <div className="container">
          <Slide right>
            <div className="product-statement">
              <div className="product-statement-image">
                <div className="image">
                  <img
                    src={require('../../../assets/photos/product-statement/fix-statement.png')}
                    alt="features"
                  />
                </div>
              </div>

              <div className="product-statement-content">
                <div className="content right-content">
                  <span className="sub-title">The Solution</span>
                  <h2>Solving problems, building brands</h2>
                  <p>
                    Hop In offers tailored shuttle services to bridge the gap
                    between transit and the workplace.
                  </p>

                  <div className="features-text">
                    <p>
                      <i className="bx bxs-bulb"></i> Hop In works to{' '}
                      <b>mobilize existing charter and rideshare fleets.</b>
                    </p>
                  </div>

                  <div className="features-text">
                    <p>
                      <i className="bx bxs-bulb"></i> We help companies and
                      employees alike <b>improve access</b> within the daily
                      commute.
                    </p>
                  </div>
                  <div className="features-text">
                    <p>
                      <i className="bx bxs-bulb"></i> Hop In works directly with
                      enterprise clients to provide <b>customized shuttles</b>{' '}
                      around theirs and their employees' schedules.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </Slide>
        </div>
      </div>
    </>
  );
};

export default ProductStatement;
